function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
import { array, isObject } from 'vega-util';
import { getPositionChannelFromLatLong, isGeoPositionChannel, isScaleChannel, isSingleDefUnitChannel } from '../../channel';
import * as log from '../../log';
import { hasContinuousDomain } from '../../scale';
import { SELECTION_ID } from '../../selection';
import { hash, keys, varName, isEmpty } from '../../util';
import { TimeUnitNode } from '../data/timeunit';
import { assembleProjection } from './assemble';
import { isBinnedTimeUnit } from '../../timeunit';
export var TUPLE_FIELDS = '_tuple_fields';
export var SelectionProjectionComponent = /*#__PURE__*/_createClass(function SelectionProjectionComponent() {
  _classCallCheck(this, SelectionProjectionComponent);
  for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }
  this.items = items;
  this.hasChannel = {};
  this.hasField = {};
  this.hasSelectionId = false;
});
var project = {
  defined: function defined() {
    return true; // This transform handles its own defaults, so always run parse.
  },
  parse: function parse(model, selCmpt, selDef) {
    var _selCmpt$project;
    var name = selCmpt.name;
    var proj = (_selCmpt$project = selCmpt.project) !== null && _selCmpt$project !== void 0 ? _selCmpt$project : selCmpt.project = new SelectionProjectionComponent();
    var parsed = {};
    var timeUnits = {};
    var signals = new Set();
    var signalName = function signalName(p, range) {
      var suffix = range === 'visual' ? p.channel : p.field;
      var sg = varName("".concat(name, "_").concat(suffix));
      for (var counter = 1; signals.has(sg); counter++) {
        sg = varName("".concat(name, "_").concat(suffix, "_").concat(counter));
      }
      signals.add(sg);
      return _defineProperty({}, range, sg);
    };
    var type = selCmpt.type;
    var cfg = model.config.selection[type];
    var init = selDef.value !== undefined ? array(selDef.value) : null;
    // If no explicit projection (either fields or encodings) is specified, set some defaults.
    // If an initial value is set, try to infer projections.
    var _ref2 = isObject(selDef.select) ? selDef.select : {},
      fields = _ref2.fields,
      encodings = _ref2.encodings;
    if (!fields && !encodings && init) {
      var _iterator = _createForOfIteratorHelper(init),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var initVal = _step.value;
          // initVal may be a scalar value to smoothen varParam -> pointSelection gradient.
          if (!isObject(initVal)) {
            continue;
          }
          var _iterator2 = _createForOfIteratorHelper(keys(initVal)),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var key = _step2.value;
              if (isSingleDefUnitChannel(key)) {
                (encodings || (encodings = [])).push(key);
              } else {
                if (type === 'interval') {
                  log.warn(log.message.INTERVAL_INITIALIZED_WITH_POS);
                  encodings = cfg.encodings;
                } else {
                  (fields !== null && fields !== void 0 ? fields : fields = []).push(key);
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    // If no initial value is specified, use the default configuration.
    // We break this out as a separate if block (instead of an else condition)
    // to account for unprojected point selections that have scalar initial values
    if (!fields && !encodings) {
      encodings = cfg.encodings;
      if ('fields' in cfg) {
        fields = cfg.fields;
      }
    }
    var _iterator3 = _createForOfIteratorHelper(encodings !== null && encodings !== void 0 ? encodings : []),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var channel = _step3.value;
        var fieldDef = model.fieldDef(channel);
        if (fieldDef) {
          var field = fieldDef.field;
          if (fieldDef.aggregate) {
            log.warn(log.message.cannotProjectAggregate(channel, fieldDef.aggregate));
            continue;
          } else if (!field) {
            log.warn(log.message.cannotProjectOnChannelWithoutField(channel));
            continue;
          }
          if (fieldDef.timeUnit && !isBinnedTimeUnit(fieldDef.timeUnit)) {
            field = model.vgField(channel);
            // Construct TimeUnitComponents which will be combined into a
            // TimeUnitNode. This node may need to be inserted into the
            // dataflow if the selection is used across views that do not
            // have these time units defined.
            var component = {
              timeUnit: fieldDef.timeUnit,
              as: field,
              field: fieldDef.field
            };
            timeUnits[hash(component)] = component;
          }
          // Prevent duplicate projections on the same field.
          // TODO: what if the same field is bound to multiple channels (e.g., SPLOM diag).
          if (!parsed[field]) {
            // Determine whether the tuple will store enumerated or ranged values.
            // Interval selections store ranges for continuous scales, and enumerations otherwise.
            // Single/multi selections store ranges for binned fields, and enumerations otherwise.
            var tplType = type === 'interval' && isScaleChannel(channel) && hasContinuousDomain(model.getScaleComponent(channel).get('type')) ? 'R' : fieldDef.bin ? 'R-RE' : 'E';
            var p = {
              field: field,
              channel: channel,
              type: tplType,
              index: proj.items.length
            };
            p.signals = _objectSpread(_objectSpread({}, signalName(p, 'data')), signalName(p, 'visual'));
            proj.items.push(parsed[field] = p);
            proj.hasField[field] = parsed[field];
            proj.hasSelectionId = proj.hasSelectionId || field === SELECTION_ID;
            if (isGeoPositionChannel(channel)) {
              p.geoChannel = channel;
              p.channel = getPositionChannelFromLatLong(channel);
              proj.hasChannel[p.channel] = parsed[field];
            } else {
              proj.hasChannel[channel] = parsed[field];
            }
          }
        } else {
          log.warn(log.message.cannotProjectOnChannelWithoutField(channel));
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    var _iterator4 = _createForOfIteratorHelper(fields !== null && fields !== void 0 ? fields : []),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _field = _step4.value;
        if (proj.hasField[_field]) continue;
        var _p = {
          type: 'E',
          field: _field,
          index: proj.items.length
        };
        _p.signals = _objectSpread({}, signalName(_p, 'data'));
        proj.items.push(_p);
        proj.hasField[_field] = _p;
        proj.hasSelectionId = proj.hasSelectionId || _field === SELECTION_ID;
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    if (init) {
      selCmpt.init = init.map(function (v) {
        // Selections can be initialized either with a full object that maps projections to values
        // or scalar values to smoothen the abstraction gradient from variable params to point selections.
        return proj.items.map(function (p) {
          return isObject(v) ? v[p.geoChannel || p.channel] !== undefined ? v[p.geoChannel || p.channel] : v[p.field] : v;
        });
      });
    }
    if (!isEmpty(timeUnits)) {
      proj.timeUnit = new TimeUnitNode(null, timeUnits);
    }
  },
  signals: function signals(model, selCmpt, allSignals) {
    var name = selCmpt.name + TUPLE_FIELDS;
    var hasSignal = allSignals.filter(function (s) {
      return s.name === name;
    });
    return hasSignal.length > 0 || selCmpt.project.hasSelectionId ? allSignals : allSignals.concat({
      name: name,
      value: selCmpt.project.items.map(assembleProjection)
    });
  }
};
export default project;